import React, { useEffect, useState } from 'react';
// import { InputField, TextAreaField } from '../layouts/FormFields';
import { Button, Form, message, Select, Space, Switch, Upload } from 'antd';
import axios from 'axios';
// import { app } from '../config';
// import getHeaders from '../utils/authHeaders';
// import LoaderImage from '../pages/LoaderImage';
// import NoDataFound from '../layouts/NoDataFound';
import Modal from 'react-bootstrap/Modal';
import { LoadingOutlined, UploadOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { InputField, SelectField, TextAreaField } from '../../layouts/FormFields';
import NoDataFound from '../../layouts/NoDataFound';
import LoaderImage from '../LoaderImage';
import getHeaders from '../../utils/authHeaders';
import { app } from '../../config';
import useFetchProducts from '../../hooks/fetchProducts';
import AddNewImg from '../../assets/images/add-new.png';
import AddAffiliateParent from '../ShopPartner/AddAffiliateParent';
import AddPromo from './AddPromo';

const PromoCodeConfig = () => {
  const [renderList, setRenderList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [editloader, setEditLoader] = useState(false);
  const [configs, setConfigs] = useState([]);
  const [updateId, setUpdateId] = useState('');
  let location = useLocation();
  const [isWrite, setIsWrite] = useState(true);
  const [showAdd, setshowAdd] = useState(false);

  const getConfigsListing = async () => {
    console.log('Listing API Called');
    setLoader(true);
    const res = await axios.get(`${app.URL}/api/v1/admin/promocode/listing`, { headers: getHeaders() });
    // const res = await axios.get(`${app.URL}/api/v1/admin/promocode/listing`, { headers: getHeaders() });

    console.log('resresres', res);
    res.data.result.success && setRenderList(res.data.result.data.data);

    setLoader(false);
  };
  // Finding Filteresproduct based on productId
  const user = JSON.parse(localStorage.getItem('user'));
  const putAnuraCategoryListing = async (detail, configId) => {
    try {
      console.log(detail, configId);
      let id = configId;
      let userId = user?.result.data.user.userId;
      detail.userId = userId;
      setEditLoader(true);
      console.log('detail', id, detail);
      // return;
      const res = await axios.put(`${app.URL}/api/v1/admin/promocode/update/${id}`, detail, { headers: getHeaders() });

    //   const res = await axios.put(`${app.URL}/api/v1/admin/promocode/update/${id}`, detail, { headers: getHeaders() });
      setEditLoader(false);
      res.data.result.success && setConfigs([]);
      res.data.result.success && getConfigsListing();
    } catch (error) {
      console.log('error', error);
    //   console.log('error', error.response.data.result.data.errors[0].path);
            error.response.data.result.msg == 'getting some error' ? message.error('Promo Code already exist') : message.error(error.response.data.result.msg);
     
      setEditLoader(false);
    }
  };
  const prodResp = useFetchProducts();
  const products = prodResp.response ? prodResp.response.data : [];
  // const filteredproducts = products && renderList ? products.filter((product) => renderList.some((renderItem) => renderItem.productId != product.productId)) : [];

  // Extract productIds from renderList
//   const renderProductIds = new Set(renderList.map((item) => item.productId));

  // Filter products that are NOT in renderList
//   const filteredproducts = products.filter((product) => !renderProductIds.has(product.productId));
//   console.log('products', products);
//   console.log('renderList', renderList);

//   console.log('filteredproducts', filteredproducts);
  useEffect(() => {
    getConfigsListing();
    const [filteredRoute] = user.result.data.permission.filter((item) => item.action === location.pathname.slice(1));
    setIsWrite(filteredRoute.isWrite);
  }, []);
  useEffect(() => {
    getConfigsListing();
    const [filteredRoute] = user.result.data.permission.filter((item) => item.action === location.pathname.slice(1));
    setIsWrite(filteredRoute.isWrite);
  }, [showAdd == false]);

  // const onFinish = (values) => {
  //   let updateData = {
  //     displayName: values.displayName,
  //     value: values.value,
  //   };
  //   setUpdateId(values.configId);
  //   putAnuraCategoryListing(updateData, values.configId);
  // };
  // const onFinishFailed = () => {};
  return (
    <div className='dashboard-card pb-5 container-fluid'>
      <div className='row p-0 pb-4'>
        <div className='for-before col-12 col-md-7 head fs-3 fw-bold' style={{ backgroundColor: '#a7c1d9', borderBottomRightRadius: '10px', color: '#FFFFFF' }}>
          PromoCode Config
        </div>
      </div>
      <div className='mt-2'>
        <div className='row  justify-content-end'>
          {/* <div className=' icon-btn  col-3 '></div>
          <div className=' icon-btn  col-3 '></div> */}
          <div className=' icon-btn  col-3 mr-4 justify-content-center ' style={{ width: '200px', marginRight: '250px' }} onClick={() => setshowAdd(true)}>
            <img src={AddNewImg} />
            <p>Add PromoCode</p>
          </div>
        </div>
        {loader && <LoaderImage />}
        {!loader && renderList.length === 0 && <NoDataFound />}
        {!loader && renderList.length > 1 && (
          <table id='customers' className='px-3 facial-scan-cat-table config ' style={{ width: '85%' }}>
            <thead>
              <tr>
                <th className='col-md-3 col-4'>Promo Code </th>

                <th className='col-md-5 col-4 '>Description</th>
                <th className='col-md-2 col-4  text-centre'>Discount</th>
                <th className='col-md-2 col-4 text-start'>Action</th>
                <th className='col-md-2 col-4 text-start'></th>
              </tr>
            </thead>
          </table>
        )}
        {!loader && renderList.map((item, indx) => <ConfigurationDetails isWrite={isWrite} indx={indx} item={item} editloader={editloader} setUpdateId={setUpdateId} updateId={updateId} configs={configs} setConfigs={setConfigs} putAnuraCategoryListing={putAnuraCategoryListing} />)}
      </div>
      {showAdd && <AddPromo show={showAdd} setShow={setshowAdd} handleClose={() => setshowAdd(false)} products={products} />}
    </div>
  );
};

const ConfigurationDetails = ({ isWrite, indx, item, updateId, configs, setConfigs, editloader, setUpdateId, putAnuraCategoryListing, filteredproducts, products }) => {
  const [videoUrl, setVideoUrl] = useState(item.value);
  const [contentType, setContentType] = useState();
  const [uplVid, setuplVid] = useState(true);
  const [isActive, setisActive] = useState();
  // State management for image
  const [imageUrl, setImageUrl] = useState(item.value);
  const [uplImg, setuplImg] = useState(true);
  //  const [prodDataa, setprodData] = useState([]);
  // const products = useFetchProducts();

  // Video related functions
  const VideoToggle = () => {
    setVideoUrl('');
    setTimeout(() => setVideoUrl(item.value), 500);
  };
  // useEffect(() => {
    
  // },[])

  // Image related functions
  const ImageToggle = () => {
    setImageUrl('');
    setTimeout(() => setImageUrl(item.value), 500);
  };

  const beforeUpload = (file) => {
    console.log(file);
    setVideoUrl('');
    setImageUrl('');
    if (file.type === 'image/jpeg' || file.type === 'image/png') {
      console.log('setting image type');
      setContentType('img');
    } else if (file.type === 'video/x-matroska' || file.type === 'video/mp4') {
      setContentType('video');
    }
    const isSupportedFileType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'video/x-matroska' || file.type === 'video/mp4';
    if (!isSupportedFileType) {
      message.error('You can only upload JPG/PNG/MP4/MKV files!');
    }
    console.log('file Checked');
    const isLtSizeLimit = file.size / 1024 / 1024 < (file.type.includes('video') ? 60 : 5);
    if (!isLtSizeLimit) {
      setLargeFile(true);
      message.error(file.type.includes('video') ? 'Video must be smaller than 60MB!' : 'Image must be smaller than 5MB!');
    }
    console.log('message');
    return isSupportedFileType && isLtSizeLimit;
  };

  const handleuploadChange = (info) => {
    if (info.file.status === 'uploading') {
      return;
    }
    if (info.file.status === 'done') {
      if (info.file.type.includes('video')) {
        info.file ? setVideoUrl(info.file.response.data.Location) : ' ';
      } else {
        info.file ? setImageUrl(info.file.response.data.Location) : ' ';
      }
    }
  };
  //   // console.log("item",item)
  //   useEffect(() => {
  //     if (videoUrl !== item.value || imageUrl !== item.value) {
  //       if (!configs.includes(item.configId)) {
  //         setConfigs([...configs, item.configId]);
  //       }
  //     } else {
  //       const filterId = configs.filter((id) => id !== item.configId);
  //       setConfigs(filterId);
  //     }
  //   }, [videoUrl, imageUrl]);

  const onFinish = (values) => {
    console.log('values', values);

    // let updateData = {
    //   productId: values.productId,
    //   rangeFrom: values.rangeFrom,
    //   rangeTo: values.rangeTo,

    //   isActive: values.isActive,
    //   // webRoute: values.webRoute,
    //   percentage: values.percentage,

    //   // index: values.index ? values.index : 1000,
    //   // isMenuRoute: 1,

    //   //   webRoutes: item.type === 'video' ? videoUrl : item.type === 'num' ? values.value : item.type == 'bool' ? (isActive == true ? '1' : '0') : imageUrl,
    // };
    setUpdateId(values.promoCodeId);
    // console.log('updateData', updateData);
    // return
    putAnuraCategoryListing(values, values.configId);
  };
  const preventKeyPress = (event) => {
    event.preventDefault();
  };

  const onFinishFailed = () => {};
  return (
    <>
      <Form
        key={indx}
        name='basic'
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
        initialValues={{
          remember: true,
          ['promoCode']: item.promoCode,
          ['discount']: item.discount,
          //   ['rangeTo']: item.rangeTo,
            ['description']: item.description,
          ['isActive']: item.isActive,
          ['configId']: item.promoCodeId,
          //   ['directPrint']: item.value == '1' ? true : false, // Ensuring boolean conversion
        }}
        className='row px-3'
      >
        {/* <SelectField
          // label='Duration'
          name='productId'
          col='col-2'
          required={true}
          placeholder='productId'
          options={products?.map((item) => (
            <Select.Option value={item.productId}>{item.name}</Select.Option>
          ))}
          rules={[
            {
              required: true,
              message: 'Select productId',
            },
          ]}
          onChange={(e) => {
            console.log(e);
            if (e !== item.productId) {
              if (!configs.includes(item.id)) {
                setConfigs([...configs, item.id]);
              }
            } else {
              const filterId = configs.filter((id) => id !== item.id);
              setConfigs(filterId);
            }
            console.log('e.target.value, item.name,', configs);
          }}
        /> */}

        <InputField
          col='col-md-2 col-4'
          name='promoCode'
          className=' p-0' // Removes box styles
          // label='Name'
          // style={{backgroundColor:'grey'}}
          // style={{/ color: 'black' }}
          placeholder='Enter promo code '
          //   onKeyPress={(e) => {
          //     // const charCode = e.charCode;
          //     // if (charCode == 46) {
          //     //   return;
          //     // }
          //     // if (charCode < 48 || charCode > 57) {
          //     //   e.preventDefault(); // Prevent non-numeric characters
          //     // }
          //   }}
          onChange={(e) => {
            let value = e.target.value;

            // // Restrict input to numbers between 0 and 100
            // if (value && (Number(value) < 0 || Number(value) > 100)) {
            //   e.target.value = value.slice(0, -1); // Remove invalid input
            //   return;
            // }

            // Check if value is different from rangeFrom and update configs accordingly
            if (value !== item.promoCode) {
              if (!configs.includes(item.promoCodeId)) {
                setConfigs([...configs, item.promoCodeId]);
              }
            } else {
              const filterId = configs.filter((id) => id !== item.promoCodeId);
              setConfigs(filterId);
            }
          }}
        />

        <InputField
          col='col-md-4 col-4'
          name='description'
          className=' p-0' // Removes box styles
          // label='Name'
          // style={{backgroundColor:'grey'}}
          // style={{/ color: 'black' }}
          placeholder='Enter description '
          //   onKeyPress={(e) => {
          //     // const charCode = e.charCode;
          //     // if (charCode == 46) {
          //     //   return;
          //     // }
          //     // if (charCode < 48 || charCode > 57) {
          //     //   e.preventDefault(); // Prevent non-numeric characters
          //     // }
          //   }}
          onChange={(e) => {
            let value = e.target.value;

            // // Restrict input to numbers between 0 and 100
            // if (value && (Number(value) < 0 || Number(value) > 100)) {
            //   e.target.value = value.slice(0, -1); // Remove invalid input
            //   return;
            // }

            // Check if value is different from rangeFrom and update configs accordingly
            if (value !== item.description) {
              if (!configs.includes(item.promoCodeId)) {
                setConfigs([...configs, item.promoCodeId]);
              }
            } else {
              const filterId = configs.filter((id) => id !== item.promoCodeId);
              setConfigs(filterId);
            }
          }}
        />
        {/* </Form.Item> */}
        <InputField
          col='col-md-2 col-4'
          name='discount'
          className='border-0'
          // label='Name'
          // disabled={true}
          // style={{ color: 'black' }}
          // onKeyDown={(e) => preventKeyPress(e)}
          placeholder='Enter discount'
          // rules={[
          //   {
          //     required: true,
          //     message: 'Enter Display Name',
          //   },
          // ]}
          // readOnly={true}
          onKeyPress={(e) => {
            let next = e.key;
            let value = e.target.value;
            console.log('e', e.target.value, typeof next, typeof value);

            if (value && next && Number(value + next) > 100) {
              console.log('in');
              e.preventDefault();
              return;
            }
            console.log('e', e.target.value, e);
            const charCode = e.charCode;
            if (charCode == 46) {
              return;
            }
            if (charCode < 48 || charCode > 57) {
              e.preventDefault();
            }
          }}
          onChange={(e) => {
            let value = e.target.value;

            // Restrict input to numbers between 0 and 100
            // if (value && (Number(value) < 0 || Number(value) > 100)) {
            //   e.target.value = value.slice(0, -1); // Remove invalid input
            //   return;
            // }

            // Check if value is different from rangeFrom and update configs accordingly
            if (value !== item.discount) {
              if (!configs.includes(item.promoCodeId)) {
                setConfigs([...configs, item.promoCodeId]);
              }
            } else {
              const filterId = configs.filter((id) => id !== item.promoCodeId);
              setConfigs(filterId);
            }
          }}
        />

        <div className='col-md-2 col-5'>
          <Form.Item className='selector-main   ' colon={false} valuePropName='checked' name='isActive'>
            <Switch
              // checked={item.directPrint == 1}
              onChange={(e) => {
                console.log('config', item, e);
                setisActive(e);
                //  form.setFieldsValue({ [item.configId]: checked });
                if (e !== (item.isActive == 1 ? true : false)) {
                  if (!configs.includes(item.promoCodeId)) {
                    setConfigs([...configs, item.promoCodeId]);
                  }
                } else {
                  const filterId = configs.filter((id) => id !== item.promoCodeId);

                  setConfigs(filterId);
                }
              }}
            />
          </Form.Item>
        </div>
        {item.type === 'text' && (
          <TextAreaField
            col='col-md-4 col-5'
            name='value'
            // label='Display Position'
            placeholder='Enter Value'
            rules={[
              {
                required: true,
                message: 'Enter Value',
              },
            ]}
            rows={3}
            // required={true}
            onChange={(e) => {
              if (e.target.value !== item.value) {
                if (!configs.includes(item.configId)) {
                  setConfigs([...configs, item.configId]);
                }
              } else {
                const filterId = configs.filter((id) => id !== item.configId);
                setConfigs(filterId);
              }
            }}
          />
        )}
        {item.type === 'video' && (
          <div className='col-md-4 col-12 mb-3 bg-light py-2 rounded image-column'>
            {videoUrl && (
              <video className='m-0' style={{ width: '100%', borderRadius: '5px', boxShadow: '3px 3px 10px #ccc' }} controls title='Video player'>
                <source src={videoUrl} type='video/mp4'></source>
              </video>
            )}
            <Form.Item colon={false} className='mt-2'>
              <Space
                direction='vertical'
                style={{
                  width: '100%',
                }}
                size='large'
              >
                <Upload onRemove={VideoToggle} listType='picture' maxCount={1} className='avatar-uploader' headers={getHeaders()} action={`${app.URL}/api/v1/general/config/videoupload`} beforeUpload={beforeUpload} onChange={handleuploadChange}>
                  <Button icon={<UploadOutlined />} className={'upload-btn'} style={{ color: 'black' }}>
                    Upload Video
                  </Button>
                  <div className='mt-2'>Note: Upload size for video is 50mb supported format for video are (mkv/mp4)</div>
                </Upload>
              </Space>
            </Form.Item>
          </div>
        )}
        {item.type === 'image' && (
          <div className='col-md-4 col-12 mb-3 bg-light py-2 rounded image-column'>
            {imageUrl && <img src={imageUrl} alt='Uploaded Image' className='m-0' style={{ width: '100%', borderRadius: '5px', boxShadow: '3px 3px 10px #ccc' }} />}
            <Form.Item colon={false} className='mt-2'>
              <Space
                direction='vertical'
                style={{
                  width: '100%',
                }}
                size='large'
              >
                <Upload onRemove={ImageToggle} listType='picture' maxCount={1} className='avatar-uploader' headers={getHeaders()} action={`${app.URL}/api/v1/general/config/logoupload`} beforeUpload={beforeUpload} onChange={handleuploadChange}>
                  <Button icon={<UploadOutlined />} className={'upload-btn'} style={{ color: 'black' }}>
                    Upload Image
                  </Button>
                  <div className='mt-2'>Note: Upload size for images is 5MB, supported formats are (jpg/png/jpeg)</div>
                </Upload>
              </Space>
            </Form.Item>
          </div>
        )}
        {item.type === 'bool' && (
          <Form.Item className='selector-main   ' colon={false} valuePropName='checked' name='directPrint'>
            <Switch
              // checked={item.directPrint == 1}
              onChange={(e) => {
                console.log('config', item, e);
                setisActive(e);
                //  form.setFieldsValue({ [item.configId]: checked });
                if (e !== (item.value == 1 ? true : false)) {
                  if (!configs.includes(item.configId)) {
                    setConfigs([...configs, item.configId]);
                  }
                } else {
                  const filterId = configs.filter((id) => id !== item.configId);

                  setConfigs(filterId);
                }
              }}
            />
          </Form.Item>
          // </div>
        )}
        {item.type === 'num' && (
          <InputField
            col='col-md-2 col-3'
            name='value'
            // label='Name'
            placeholder={`Enter Value ${item.key === 'sampleWaitingTime' && '(minutes)'}`}
            rules={[
              {
                required: true,
                message: 'Enter Value',
              },
            ]}
            type='number'
            onChange={(e) => {
              console.log('checkc', e.target.value, item.value);
              if (e.target.value !== item.value) {
                if (!configs.includes(item.configId)) {
                  setConfigs([...configs, item.configId]);
                }
              } else {
                const filterId = configs.filter((id) => id !== item.configId);
                setConfigs(filterId);
              }
            }}
          />
        )}
        <Form.Item className='d-none selector-main' colon={false} valuePropName='checked' name='configId'></Form.Item>
        {configs.includes(item.promoCodeId) && isWrite && (
          <div className='col-2 pt-1  ' style={{ marginLeft: '-100px' }}>
            <Button className=' btn btn-primary' htmlType='submit'>
              {editloader && item.promoCodeId === updateId ? <LoadingOutlined /> : 'Update'}
            </Button>
          </div>
        )}
      </Form>
    </>
  );
};

export default PromoCodeConfig;
